import "./CookieBanner.scss";

const CookieBanner = () => {
  return (
    <>
      <p className="text">
        We use cookies to make your experience better! If you continue to use
        this site we will assume that you are happy with it.
      </p>
      <button className="accept">Agree & Close</button>
    </>
  );
};
export default CookieBanner;
